"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.staytime = exports.soundNames = exports.jsonNames = exports.GameLoadConfig = exports.GameConfig = void 0;
const ajv_1 = __importDefault(require("ajv"));
const GameConfigValidate = ajv_1.default().compile({
    type: "object",
    properties: {
        judgeOffset: { type: "number" },
        visualOffset: { type: "number" },
        speed: { type: "number", minimum: 1, exclusiveMaximum: 12 },
        resolution: { type: "number", minimum: 0.1, maximum: 8 },
        noteScale: { type: "number", minimum: 0.01, maximum: 4 },
        barOpacity: { type: "number", minimum: 0, maximum: 1 },
        backgroundDim: { type: "number", minimum: 0, maximum: 1 },
        effectVolume: { type: "number", minimum: 0, maximum: 1 },
        showSimLine: { type: "boolean" },
        laneEffect: { type: "boolean" },
        mirror: { type: "boolean" },
        beatNote: { type: "boolean" },
        autoplay: { type: "boolean" },
        debug: { type: "boolean" },
    },
});
class GameConfig {
    constructor() {
        this.judgeOffset = 0;
        this.visualOffset = 0;
        this.speed = 10;
        this.resolution = 2;
        this.noteScale = 1;
        this.barOpacity = 0.7;
        this.backgroundDim = 0.7;
        this.effectVolume = 1;
        this.showSimLine = true;
        this.laneEffect = true;
        this.mirror = false;
        this.beatNote = true;
        this.autoplay = false;
        // showTapOffset = true
        this.debug = false;
    }
    static validate(config) {
        if (GameConfigValidate(config))
            return config;
        console.error(GameConfigValidate.errors);
    }
}
exports.GameConfig = GameConfig;
const GameLoadConfigValidate = ajv_1.default().compile({
    type: "object",
    properties: {
        musicSrc: { type: "string", minLength: 1 },
        backgroundSrc: { type: "string", minLength: 1 },
        coverSrc: { type: "string", minLength: 1 },
        skin: { type: "string", minLength: 1 },
        songName: { type: "string" },
        loadingMessages: { type: "array", items: { type: "string" } },
    },
    required: ["musicSrc", "skin"],
});
class GameLoadConfig {
    constructor() {
        this.musicSrc = "";
        this.mapContent = null;
        this.backgroundSrc = "";
        this.coverSrc = "";
        this.skin = "";
        this.sound = "";
        this.songName = "";
    }
    static validate(config) {
        if (GameLoadConfigValidate(config)) {
            const mapContent = config.mapContent;
            if (mapContent && mapContent instanceof Object)
                return config;
            console.error("invalid mapContent property", mapContent);
            return;
        }
        console.error(GameLoadConfigValidate.errors);
    }
}
exports.GameLoadConfig = GameLoadConfig;
exports.jsonNames = {
    effect: "effect.json",
    game: "game.json",
    ui: "ui.json",
};
exports.soundNames = {
    flick: "flick.mp3",
    button: "game_button.mp3",
    good: "good.mp3",
    great: "great.mp3",
    long: "long.mp3",
    perfect: "perfect.mp3",
};
function staytime(speed) {
    return 5.5 - (speed - 1) / 2;
}
exports.staytime = staytime;
//# sourceMappingURL=GameConfig.js.map